export default "__VITE_ASSET__86944a43__"